const BASE_URL = "https://ignosi.in/websiteapi";

export default BASE_URL;
